import * as React from 'react';

import Entity from 'components/entity/Entity';
import EntityAvatar from 'components/entity/entity-avatar/EntityAvatar';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { abbrNum } from 'utils/helper/common';
import { renderPrice } from 'utils/helper/price';

import './ccm-campaign-reporting-table-outfit-details-items.scss';

import type {
  CcmCampaignReportingOutfitDetailsItem
} from 'modules/campaigns/components/ccm/types/CcmCampaignReporting.type';

type Props = {
  items: Array<CcmCampaignReportingOutfitDetailsItem>
};

const CcmCampaignReportingTableOutfitDetailsItems: React.FC<Props> = ({
  items
}): JSX.Element => {
  const renderEntity = (
    item: CcmCampaignReportingOutfitDetailsItem
  ): React.ReactNode => (
    <Entity>
      <EntityAvatar
        entity={{
          id: item.id,
          firstName: item.itemSku,
          lastName: '',
          image: { url: item.imageUrl },
          displayName: ''
        }}
        bordered
        form="square"
        size="customSize"
        customSize={{
          width: 56,
          height: 56
        }}
      />
    </Entity>
  );

  const renderInformation = (
    item: CcmCampaignReportingOutfitDetailsItem
  ): React.ReactNode => (
    <div className="ccm-campaign-reporting-table-outfit-details-items__meta text-overflow-ellipsis">
      <div
        className="ccm-campaign-reporting-table-outfit-details-items__meta-main text-overflow-ellipsis"
        title={item.itemSku}
      >
        {item.itemSku}
      </div>
    </div>
  );

  const renderPreview = (
    item: CcmCampaignReportingOutfitDetailsItem
  ): React.ReactNode => (
    <div className="ccm-campaign-reporting-table-outfit-details-items__preview">
      <a
        href={item.itemPreview}
        target="_blank"
        rel="noopener noreferrer"
      >
        <SVGDynamicIcon
          name="link-external-custom-fg"
          customColor="grey"
          width={17}
          height={17}
          onClick={(event) => event.stopPropagation()}
        />
      </a>
    </div>
  );

  const renderMetrics = (
    item: CcmCampaignReportingOutfitDetailsItem
  ): React.ReactNode => (
    <div className="ccm-campaign-reporting-table-outfit-details-items__metrics">
      <div className="ccm-campaign-reporting-table-outfit-details-items__metrics--product-page-views">
        {abbrNum(item.metrics.itemProductPageViews, { decimal: 1 }, true)}
      </div>
      <div className="ccm-campaign-reporting-table-outfit-details-items__metrics--num-items-sold">
        {abbrNum(item.metrics.itemNumItemsSold, { decimal: 1 }, true)}
      </div>
      <div className="ccm-campaign-reporting-table-outfit-details-items__metrics--revenue">
        {renderPrice(item.metrics.itemRevenue)}
      </div>
    </div>
  );

  return (
    <div className="ccm-campaign-reporting-table-outfit-details-items">
      {
        items.map(item => (
          <div
            key={`ccm-campaign-reporting-table-outfit-details-items--${item.id}-${item.itemSku}`}
            className="ccm-campaign-reporting-table-outfit-details-items__item"
          >
            <div className="ccm-campaign-reporting-table-outfit-details-items__item-info text-overflow-ellipsis">
              {renderEntity(item)}
              {renderInformation(item)}
            </div>
            {renderPreview(item)}
            {renderMetrics(item)}
          </div>
        ))
      }
    </div>
  );
};

export default CcmCampaignReportingTableOutfitDetailsItems;
